module.exports = __webpack_public_path__ + "static/1-d6b3ca28d0567bfb85ab981da5d3b087.png";